import * as Sentry from "@sentry/react";

// Env-gated: only initialises when REACT_APP_SENTRY_DSN is set. A complete
// no-op otherwise (dev/preview run unchanged). Sentry.ErrorBoundary still works
// as a UI fallback even when Sentry is not initialised.
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
  });
}

export { Sentry };
